module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_vm._v("CAPTIONS FOR COVER PICTURES")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Front Cover")]), _vm._v(" Arriving at the end of its journey to serve collieries at Blaengarw with empty wagons from Margam Yard, Tondu-based 4200 Class No. 4251 pulls into the yard, showing the south end of the complex under the control of the signal box located on the extreme left of the picture. "), _c('span', {
    staticClass: "source"
  }, [_vm._v("(B.W.L. Brooksbank/Initial Photographics)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-84ed0bde","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Frontmatter.vue
// module id = 72
// module chunks = 0